/* eslint-disable prefer-reflect */
import axios from "axios";
import { PLATFORM } from "../config.js";
import { SETTINGS } from "../config.js";

const call = (props) => {
  return axios({
    ...props,
    baseURL: SETTINGS[PLATFORM].REACT_APP_BASE_URL,
    mode: "cors",
    timeout: 10000, // Timeout set to 3000ms (3 seconds)
  });
};

export default {
  fetchManifests: (releasePath) => {
    if (releasePath) {
      return call({
        method: "get",
        url: `${releasePath}/index.json`,
      });
    }

    return call({
      method: "get",
      url: "index.json",
    });
  },

  fetchManifest: (manifest) => {
    return call({
      method: "get",
      url: `${manifest}`,
    });
  },
};
